<template>
    <div id="app">
        <div class="nav-title">
            <van-icon v-if="showBackBtn" name="arrow-left" @click="$router.go(-1)"/>
            <van-icon v-else name="null" />
            <div>{{nav_title}}</div>
            <img style="width:25px;" @click="language_cut" src="./assets/images/language.png">
            <!-- <div style="width:16px;height:100%;"></div> -->
        </div>
        <div class="nav-bg-title"></div>

        <router-view/>
        <div class="nav-bg-title"></div>
        <van-tabbar v-model="active" class="active_tab" id="q1">
            <van-tabbar-item v-for="(item,index) in tabbars" :key="index" @click="tab(index,item.name)">
                <template slot="icon" slot-scope="props">
                    <img :src="props.active ? item.active : item.normal">
                </template>
            </van-tabbar-item>
        </van-tabbar>
        <div v-if="showTip" id="weixinTip" ref="weixin" class="wxtip">
            <p class="wxtip-txt">
                {{tipMessage.title}}
                <br />
                {{tipMessage.message1}}
                <br />
                {{tipMessage.message2}}
            </p>
        </div>
    </div>
</template>

<script>
    import {Dialog} from 'vant';
    export default {
        data() {
            return {
                tipMessage : {
                    title: '在微信中无法打开海嘉商城',
                    message1: '1. 请点击右上角按钮',
                    message2: '2. 选择【在浏览器中打开】',
                },
                currIndex: 0,
                active: 0,
                nav_title: '',
                showTip: false,
                showBackBtn: false,
                tabbars: [
                    {
                        name: "list",
                        normal: require("./assets/images/list.png"),
                        active: require("./assets/images/list_acivte.png")
                    },
                    {
                        name: "shopping_trolley",
                        normal: require('./assets/images/shopping_trolley.png'),
                        active: require('./assets/images/shopping_trolley_active.png')
                    },
                    {
                        name: "order_form",
                        normal: require('./assets/images/order_form.png'),
                        active: require('./assets/images/order_form_active.png')
                    },
                ]
            }
        },
        mounted() {
            if (!sessionStorage.shopping_trolley_list) {
                sessionStorage.setItem('shopping_trolley_list', JSON.stringify([]))
            }
            sessionStorage.language == 'en' ? this.nav_title = 'BIBA' : this.nav_title = '海嘉学校 '
            sessionStorage.language == 'en' ? this.tipMessage.title = 'Cannot open BIBA Mall in WeChat' : this.tipMessage.title = '在微信中无法打开海嘉商城 '
            sessionStorage.language == 'en' ? this.tipMessage.message1 = '1.Please click the button in the upper right corner' : this.tipMessage.message1 = '1. 请点击右上角按钮 '
            sessionStorage.language == 'en' ? this.tipMessage.message2 = '2.Select [Open in browser]' : this.tipMessage.message2 = '2. 选择【在浏览器中打开】 '

        },
        watch: {
            '$route'() {
                if (this.$route.matched[0].path == '') {
                    this.showBackBtn = false
                } else {
                    this.showBackBtn = true
                }
            }
        },
        created() {
            if (this.$route.matched[0].path == '') {
                this.showBackBtn = false
            } else {
                this.showBackBtn = true
            }
            // 如果第一次进入网页，默认存储语言为中文
            if (!sessionStorage.language) {
                sessionStorage.setItem('language', 'ch')
            }
            this.show_path()
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                // 是微信端
                this.showTip = true


            }
        },
        // watch:{
        //     $route(to,from){
        //         this.show_path()
        //     }
        // },
        methods: {
            language_cut() {     // 语言切换
                sessionStorage.language == 'ch' ? sessionStorage.setItem('language', 'en') : sessionStorage.setItem('language', 'ch')
                this.$router.go(0)
            },
            show_path() {
                if (this.$route.path.indexOf('list') > 0) {
                    this.active = 0
                } else if (this.$route.path.indexOf('shopping_trolley') > 0) {
                    this.active = 1
                } else if (this.$route.path.indexOf('order_form') > 0) {
                    this.active = 2
                } else {
                    this.active = 0
                }
            },
            tab(index, val) {
                this.show_path()
                if (this.active != index) {
                    this.active = index;
                    this.currIndex = index;
                    this.$router.push(val);
                }
            }
        },
    }
</script>
<style lang="less">
    html, body, #app {
        height: 100%;
        background-color: #F2F2F2;
    }

    .nav-title {
        width: 100%;
        height: 0.9rem;
        line-height: 0.9rem;
        text-align: center;
        color: #FFF;
        background-color: #093268;
        position: fixed;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 0.3rem;
        box-sizing: border-box;
        z-index: 999;
        .van-icon {
            width: 16px;
        }
    }

    .nav-bg-title {
        width: 100%;
        height: 0.9rem;
    }
    .wxtip {
        background: rgba(0, 0, 0, 0.8);
        text-align: center;
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 100;
        img {
            width: 100%;
        }
    }

    .wxtip-txt {
        margin-top: 107px;
        color: #fff;
        font-size: 20px;
        line-height: 1.8;
    }
</style>
